import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import Signin from '../components/Signin'

export const Route = createFileRoute('/signin')({
  component: Signin,
  validateSearch: z.object({
    redirect: z.string().optional(),
  }),
})
